import { render, staticRenderFns } from "./advanceTrainingSettingsComponent.vue?vue&type=template&id=60b9d797&scoped=true"
import script from "./advanceTrainingSettingsComponent.vue?vue&type=script&lang=js"
export * from "./advanceTrainingSettingsComponent.vue?vue&type=script&lang=js"
import style0 from "./advanceTrainingSettingsComponent.vue?vue&type=style&index=0&id=60b9d797&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b9d797",
  null
  
)

export default component.exports